<template>
    <div class="movie-item">
        <div class="card-image" @click="$router.push(`/movie/${movie.id}`)">
            <div v-if="!imageLoaded" class="skeleton"></div>
            <img
                class="image"
                :src="cardImage"
                :style="{ opacity: imageLoaded ? 1 : 0, position: imageLoaded ? 'relative' : 'absolute' }"
                @load="imageLoaded = true"
                alt=""
            />
            <div class="icon-wrapper">
                <Icon icon="material-symbols:play-circle-outline" width="70" />
                <span class="watch-label">{{ $t('banner.watchNow') }}</span>
                <span class="free-label">{{ $t('banner.free') }}</span>
            </div>
        </div>
        <div class="card-info">
            <span>{{ this.title }}</span>
            <p v-if="discr">{{ this.discription }}</p>
        </div>
        <div class="movie-star">
            <p>
                <Icon icon="material-symbols:star-rounded" color="white" />
                <span>{{ movie.vote_average.toFixed(1) }}</span>
            </p>
        </div>
    </div>
</template>

<script>
import getImage from '@/lib/getImage';
import { Icon } from '@iconify/vue';

export default {
    components: {
        Icon
    },
    data() {
        return {
            discription: '',
            title: '',
            imageLoaded: false
        }
    },
    props: {
        movie: {
            type: Object,
            required: true
        },
        discr: {
            type: Boolean
        }
    },
    computed: {
        cardImage() {
            this.discription = this.movie.overview.length <= 150 ? this.movie.overview : this.movie.overview.slice(0, 150) + "...";
            this.title = this.movie.title <= 60 ? this.movie.title : this.movie.title.slice(0, 50);
            const image = getImage(this.movie.poster_path);
            return `${image}`
        },
    },

}

</script>

<style scoped>
.movie-item {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    width: 100%;
    position: relative;
}

.card-image {
    width: 100%;
    overflow: hidden;
    position: relative;
    cursor: pointer;
}

.skeleton {
    width: 100%;
    aspect-ratio: 2/3;
    border-radius: 15px;
    background: linear-gradient(90deg, #1f1f1f 25%, #2e2e2e 50%, #1f1f1f 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}

.image {
    width: 100%;
    object-fit: fill;
    border-radius: 15px;
    transition: opacity 0.3s ease;
}

.image:hover {
    webkit-filter: blur(4px);
    filter: blur(4px);
    cursor: pointer;
}

.icon-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: white;
    align-items: center;
    gap: 8px;
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    right: 50%;
    top: 50%;
    transition: 0.5s;
    transform: translate(50%, -50%);
    background: rgba(0,0,0,0.75);
    border-radius: 15px;
}

.icon-wrapper:hover {
    opacity: 1;
}

.watch-label {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.05em;
}

.free-label {
    font-size: 11px;
    color: rgb(34 197 94);
    font-weight: 600;
    background: rgb(34 197 94 / 0.15);
    border: 1px solid rgb(34 197 94 / 0.4);
    border-radius: 20px;
    padding: 3px 10px;
}

.card-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: white;
    margin-top: 10px;
}

.card-info span {
    font-size: 20px;
}

.card-info p {
    opacity: 70%;
    text-align: justify;
    margin-top: 5px;
}

.movie-star {
    position: absolute;
    top: 10px;
    right: 10px;
    border-radius: 5px;
    padding: 10px 10px;
    background-color: rgb(4 120 87);

}

.movie-star p {
    display: flex;
    align-items: center;
    justify-items: center;
    gap: 5px;
    color: white;
}

@media only screen and (max-device-width: 480px) {
    .card-info p {
        display: none;
    }

    .card-info span {
        font-size: small;
    }

    .movie-star {
        padding: 3px 3px;
        background-color: rgb(4 120 87);
        font-size: small;
        top: 5px;
        right: 5px;
    }
}
</style>